export default __webpack_public_path__ + "images/pictograms/account-access.svg?a9c4564b17f8711d4c5ee819fbdc32943ba240d3bb46d7ba05f6bcc969ec02da";